// Central registry of data-testid values used across the app.
export const HOME = {
  emergentLink: "home-emergent-link",
};

export const NAV = {
  logo: "nav-logo",
  simulatorLink: "nav-simulator-link",
  rulesLink: "nav-rules-link",
};

export const LANDING = {
  ctaStart: "landing-cta-start",
  ctaRules: "landing-cta-rules",
};

export const SIM = {
  container: "simulator-container",
  // Progressive steps
  step1: "sim-step-1",
  step2: "sim-step-2",
  step3: "sim-step-3",
  step4: "sim-step-4",
  step5: "sim-step-5",
  step6: "sim-step-6",
  step7: "sim-step-7",
  step8: "sim-step-8",
  step9: "sim-step-9",
  step10: "sim-step-10",
  step11: "sim-step-11",
  packageCard: (id) => `sim-package-card-${id}`,
  myPackageSelect: "sim-my-package-select",
  directsSlider: "sim-directs-slider",
  directsValue: "sim-directs-value",
  duplicationSlider: "sim-duplication-slider",
  duplicationValue: "sim-duplication-value",
  monthsSlider: "sim-months-slider",
  monthsValue: "sim-months-value",
  daysPerGenSlider: "sim-days-per-gen-slider",
  daysPerGenValue: "sim-days-per-gen-value",
  directPackageSelect: "sim-direct-package-select",
  l2PerDirectSlider: "sim-l2-per-direct-slider",
  l2PerDirectValue: "sim-l2-per-direct-value",
  l2PackageSelect: "sim-l2-package-select",
  l3PerL2Slider: "sim-l3-per-l2-slider",
  l3PerL2Value: "sim-l3-per-l2-value",
  l4PerL3Slider: "sim-l4-per-l3-slider",
  l4PerL3Value: "sim-l4-per-l3-value",
  l5PerL4Slider: "sim-l5-per-l4-slider",
  l5PerL4Value: "sim-l5-per-l4-value",
  l6PerL5Slider: "sim-l6-per-l5-slider",
  l6PerL5Value: "sim-l6-per-l5-value",
  l7PerL6Slider: "sim-l7-per-l6-slider",
  l7PerL6Value: "sim-l7-per-l6-value",
  l8PerL7Slider: "sim-l8-per-l7-slider",
  l8PerL7Value: "sim-l8-per-l7-value",
  l9PerL8Slider: "sim-l9-per-l8-slider",
  l9PerL8Value: "sim-l9-per-l8-value",
  l10PerL9Slider: "sim-l10-per-l9-slider",
  l10PerL9Value: "sim-l10-per-l9-value",
  deeperToggle: "sim-deeper-toggle",
  deeperEnabled: "sim-deeper-enabled",
  downlinePackageSelect: "sim-downline-package-select",
  advancedToggle: "sim-advanced-toggle",
  dupMultSlider: "sim-dup-mult-slider",
  dupMultValue: "sim-dup-mult-value",
  branchSlider: "sim-branch-slider",
  branchValue: "sim-branch-value",
  retentionSlider: "sim-retention-slider",
  retentionValue: "sim-retention-value",
  advancedReset: "sim-advanced-reset",
  // Results
  resultsPanel: "sim-results-panel",
  heroCommission: "sim-hero-commission",
  heroVolume: "sim-hero-volume",
  heroShares: "sim-hero-shares",
  totalHorizon: "sim-total-horizon",
  totalMonthly: "sim-total-monthly",
  totalYearly: "sim-total-yearly",
  totalShares: "sim-total-shares",
  totalQV: "sim-total-qv",
  currentRank: "sim-current-rank",
  breakdownChart: "sim-breakdown-chart",
  levelChart: "sim-level-chart",
  breakdownIR: "sim-breakdown-ir",
  breakdownRW: "sim-breakdown-rw",
  breakdownDR: "sim-breakdown-dr",
  breakdownDM: "sim-breakdown-dm",
  rankProgress: "sim-rank-progress",
  shareBtn: "sim-share-btn",
  resetBtn: "sim-reset-btn",
  orderFlowToggle: "sim-orderflow-toggle",
};

export const RULES = {
  container: "rules-container",
  sectionSelect: "rules-section-select",
  content: "rules-content",
};
